/** Namespace `platform` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const platform = {
  title: "Lịch sử thu thập",
  subtitle: "Lượt quét, lệch schema, con trỏ đọc, và ai đã bấm gì.",
  "tab.runs": "Lịch chạy",
  "tab.drift": "Lệch schema",
  "tab.cursors": "Con trỏ",
  "tab.audit": "Sổ kiểm toán",
  loadFailed: "Không đọc được dữ liệu nền tảng.",
  empty: "Chưa có dòng nào.",

  "col.source": "Nguồn",
  "col.stream": "Luồng",
  "col.trigger": "Kiểu",
  "col.result": "Kết quả",
  "col.rows": "Số dòng",
  "col.queued": "Xếp hàng",
  "col.finished": "Xong",
  "col.status": "Trạng thái",
  "col.diff": "Cột lệch",
  "col.observedAt": "Đo lúc",
  "col.highWatermark": "Đọc tới",
  "col.lastSuccess": "Thành công cuối",
  "col.safetyWindow": "Cửa sổ an toàn",
  "col.at": "Lúc",
  "col.actor": "Ai",
  "col.action": "Hành động",
  "col.entity": "Đối tượng",
  "col.reason": "Lý do",
  system: "hệ thống",
  "auditNote.pre": "Đây là sổ ",
  "auditNote.strong": "nghiệp vụ",
  "auditNote.post":
    ": ai ánh xạ gói, ai cấp tài khoản, ai yêu cầu quét. Job bắt đầu / thử lại / hỏng nằm ở tab « Lịch chạy » — nhét chúng vào đây sẽ nhấn chìm phần cần đọc dưới hàng nghìn dòng máy sinh.",

  "run.loadFailed": "Không đọc được lượt chạy này.",
  "run.back": "← Vận hành",
  "run.watching": "đang theo dõi…",
  "run.rowsWritten": "Số dòng ghi",
  "run.requestedBy": "Ai yêu cầu",
  "run.scheduled": "theo lịch",
  "run.requestedAt": "Xếp hàng lúc",
  "run.startedAt": "Bắt đầu chạy",
  "run.finishedAt": "Xong lúc",
  "run.alreadyRunning.strong": "Không phải lỗi.",
  "run.alreadyRunning.body":
    " Một lượt khác cho cùng nguồn và luồng đang chạy, nên lượt này bỏ qua — advisory lock làm đúng việc của nó.",
  "run.note.pre": "Lượt chạy là ",
  "run.note.strong": "lịch sử",
  "run.note.mid":
    ", không phải khoá. Khoá thật là advisory lock ở Postgres, và nó tự mất khi kết nối chết — nên một dòng « đang chạy » mắc kẹt không chặn gì, nó chỉ nói dối, và tầng dọn dẹp đánh dấu nó ",
  "run.note.post": " sau vài phút.",
  // Mô tả mã lỗi connector (`ConnectorErrorCode` — tập đóng). `safeDetail` thô vẫn hiện bên dưới làm chi tiết kỹ thuật.
  "errorCode.UNREACHABLE": "Không kết nối được tới nguồn (bị từ chối, sai host hoặc mạng không tới).",
  "errorCode.AUTH_FAILED": "Nguồn từ chối thông tin đăng nhập — kiểm tra tài khoản/mật khẩu trong chuỗi kết nối.",
  "errorCode.TIMEOUT": "Nguồn không trả lời kịp trong thời hạn cho phép.",
  "errorCode.QUERY_FAILED": "Truy vấn tới nguồn bị lỗi.",
  "errorCode.CONFIG_REJECTED":
    "Nguồn từ chối cách hub kết nối (thường là connection pooler) — thử host trực tiếp, bỏ `-pooler`.",
  "errorCode.SCHEMA_DRIFT": "Schema của nguồn đã lệch so với hợp đồng — hub ngừng lấy dữ liệu để không ghi số sai.",
  "errorCode.VALIDATION_ERROR": "Dữ liệu nguồn trả về không qua được kiểm tra hợp lệ.",
  "errorCode.ALREADY_RUNNING": "Đã có một lượt khác đang chạy cho nguồn này.",
  "errorCode.LOST": "Worker không báo kết thúc lượt chạy — lượt bị đánh dấu mất dấu.",
  "errorCode.technical": "Chi tiết kỹ thuật",
} as const;
